/**
 * @fileoverview gRPC-Web generated client stub for external
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js')

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js')

var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js')
const proto = {};
proto.external = require('./mla_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.external.MLAServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.external.MLAServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.external.GetUnitsMLARequest,
 *   !proto.external.GetUnitsMLAResponse>}
 */
const methodDescriptor_MLAService_GetUnitsMLA = new grpc.web.MethodDescriptor(
  '/external.MLAService/GetUnitsMLA',
  grpc.web.MethodType.UNARY,
  proto.external.GetUnitsMLARequest,
  proto.external.GetUnitsMLAResponse,
  /**
   * @param {!proto.external.GetUnitsMLARequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.external.GetUnitsMLAResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.external.GetUnitsMLARequest,
 *   !proto.external.GetUnitsMLAResponse>}
 */
const methodInfo_MLAService_GetUnitsMLA = new grpc.web.AbstractClientBase.MethodInfo(
  proto.external.GetUnitsMLAResponse,
  /**
   * @param {!proto.external.GetUnitsMLARequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.external.GetUnitsMLAResponse.deserializeBinary
);


/**
 * @param {!proto.external.GetUnitsMLARequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.external.GetUnitsMLAResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.external.GetUnitsMLAResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.external.MLAServiceClient.prototype.getUnitsMLA =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/external.MLAService/GetUnitsMLA',
      request,
      metadata || {},
      methodDescriptor_MLAService_GetUnitsMLA,
      callback);
};


/**
 * @param {!proto.external.GetUnitsMLARequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.external.GetUnitsMLAResponse>}
 *     Promise that resolves to the response
 */
proto.external.MLAServicePromiseClient.prototype.getUnitsMLA =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/external.MLAService/GetUnitsMLA',
      request,
      metadata || {},
      methodDescriptor_MLAService_GetUnitsMLA);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.external.UpdateMLARequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_MLAService_UpdateMLA = new grpc.web.MethodDescriptor(
  '/external.MLAService/UpdateMLA',
  grpc.web.MethodType.UNARY,
  proto.external.UpdateMLARequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.external.UpdateMLARequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.external.UpdateMLARequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodInfo_MLAService_UpdateMLA = new grpc.web.AbstractClientBase.MethodInfo(
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.external.UpdateMLARequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.external.UpdateMLARequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.external.MLAServiceClient.prototype.updateMLA =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/external.MLAService/UpdateMLA',
      request,
      metadata || {},
      methodDescriptor_MLAService_UpdateMLA,
      callback);
};


/**
 * @param {!proto.external.UpdateMLARequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.external.MLAServicePromiseClient.prototype.updateMLA =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/external.MLAService/UpdateMLA',
      request,
      metadata || {},
      methodDescriptor_MLAService_UpdateMLA);
};


module.exports = proto.external;

